var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.13295 1C5.9358 1 4.76554 1.33575 3.77016 1.96478C2.77477 2.59381 1.99896 3.48788 1.54083 4.53393C1.0827 5.57997 0.962834 6.73101 1.19638 7.84148C1.42994 8.95196 2.00642 9.972 2.85292 10.7726C3.69943 11.5732 4.77795 12.1184 5.95209 12.3393C7.12623 12.5602 8.34326 12.4468 9.44928 12.0136C10.5553 11.5803 11.5006 10.8465 12.1657 9.90511C12.8308 8.96369 13.1858 7.85689 13.1858 6.72466C13.1857 5.20641 12.548 3.75038 11.4129 2.67682C10.2777 1.60326 8.73824 1.0001 7.13295 1V1Z",
    stroke: "#A18D8E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6484 11.002L15.8757 15",
    stroke: "#A18D8E",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.8e5009de0805a7672df1f648925a4319.svg";
export { ForwardRef as ReactComponent };